var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cf"},[_c('van-uploader',{attrs:{"upload-icon":_vm.roots + '/static/x0.png',"upload-text":_vm.title,"after-read":_vm.selectImage,"before-delete":_vm.befdel,"deletable":"","multiple":"","max-count":_vm.max?_vm.max:1},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c2a658a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/updata/index.vue
// module id = null
// module chunks = 